import React, {useEffect} from 'react';
import {NavLink} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {observer} from "mobx-react-lite";
import cookie from "js-cookie";
import i18next from "i18next";

import {INDEX_ROUTE} from "../utils/consts";
import {default_language, languages} from "../utils/lang";
import GenerateURL from "../utils/generateURL";

import Header from "../components/Header";

import image from '../img/logo404.svg'

const ErrorPage = props => {
  const { t } = useTranslation();
  const status = props.status || cookie.get('ErrorStatus') || 'Unknown error';
  const currentError = {
    400: {
      title: "400 Неправильний запит."
    },
    403: {
      title: "403 Доступ заборонений"
    },
    404: {
      title: "404 Сторінку не знайдено"
    },
    500: {
      title: "500 Внутрішня помилка серверу"
    },
    'Unknown error': {
      title: ""
    }
  };

  useEffect(() => {
    return () => {
      if (!(languages.some(({code}) => i18next.language === code))) {
        i18next.changeLanguage(default_language)
      }
    }
  }, []);

  return currentError[status] && (
      <div className="fhf background">
        <section>
          <Header />
        </section>
        <section className="details_content content">
          <div className="virtual">
            <div className="row">
              <div className="virtual_left">
                <div className="virtual_left_img">
                  <img src={image} alt="" />
                </div>
              </div>
              <div className="virtual_right">
                <div className="virtual_right_box">
                  <div className="title_block">
                    {status && <h1>{t(currentError[status].title)}</h1>}
                    <p>
                      {t('Вибачте, схоже, що сторінка, яку Ви шукали, більше недоступна. Будь ласка, спробуйте свою вдачу ще раз!')}
                    </p>
                  </div>
                  <div className="virtual_right_box_links">
                    <NavLink to={GenerateURL(INDEX_ROUTE)}>{t('НА ГОЛОВНУ')}</NavLink>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
  );
};

export default observer(ErrorPage);